module.exports = __webpack_public_path__ + "static/img/logo.04c61e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kaneng/logo.jpg
// module id = w75i
// module chunks = 51